import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { LoadingBar as Component } from './LoadingBar';
import { IStoreProps } from '../../Global/Store';
import { getLocation, getRedirectUrl } from './loadingBarSelectors';
import { startRedirect } from './loadingBarReducer';

const mapStateToProps = (state: IStoreProps) => ({
  location: getLocation(state),
  redirectUrl: getRedirectUrl(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  manuallyRedirect: (redirect: string) => {
    dispatch(startRedirect({ redirect }));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ILoadingBarStoreProps = ConnectedProps<typeof connector>;

export const LoadingBar = connector(Component);
